module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading02-pc-770f3c3ab0e3685f24613321bc1fbd36.png";